import './TextInputWithTokens-89115e4d.css';

var styles = {"TextInputWrapper":"prc-TextInputWithTokens-TextInputWrapper-kj1cB","UnstyledTextInput":"prc-TextInputWithTokens-UnstyledTextInput-F582M"};

export { styles as default };
